import React, { Component } from "react"
import { Grid } from "@material-ui/core"
import styled from "@emotion/styled"
import GridWrapper from "../atoms/GridWrapper"
import RowGrid from "../atoms/RowGrid"
import Main from "../organisms/seminar/MainContents"
import Title from "../atoms/Title"
import TitleDescription from "../atoms/TitleDescription"
import { withStyles } from "@material-ui/core/styles"
import { sizes, colors, templateStyles } from "../constants"

class Seminar extends Component {
  render() {
    const { classes } = this.props
    return (
      <>
        <GridWrapper>
          <Grid>
            <Grid className={classes.grid}>
              <Grid>
                <Title className={classes.title}>About Katahira Seminar</Title>
              </Grid>
              <Grid>
                <TitleDescription>
                  片平ゼミについて紹介いたします。
                </TitleDescription>
              </Grid>
            </Grid>
          </Grid>
        </GridWrapper>
        <Grid style={{ backgroundColor: colors.backGround, padding: "30px" }}>
          <Main />
        </Grid>
      </>
    )
  }
}

export default withStyles(templateStyles)(Seminar)
